import styled from "styled-components";
import errorIcon from "../../images/inputError.svg";

export const AdminImage40 = styled.img`
  width: 40px;
  height 40px;
  border-radius:50%;
  margin: ${(props) => props.margin || "0"};
  padding: ${(props) => props.padding || "0"};
  user-select: none;
`;

export const AdminImage32 = styled.img`
  width: 32px;
  height 32px;
  border-radius:50%;
  margin: ${(props) => props.margin || "0"};
  padding: ${(props) => props.padding || "0"};
  user-select: none;
`;

export const AdminImage24 = styled.img`
  width: 24px;
  height 24px;
  border-radius:50%;
  margin: ${(props) => props.margin || "0"};
  padding: ${(props) => props.padding || "0"};
`;

export const BrandTittle = styled.h2`
  width: 100%;
  color: #09274a;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  padding: ${(props) => props.padding || "0"};
  margin: ${(props) => props.margin || "28px 0 32px 0"};
`;

export const FormControl = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.padding ? props.padding : "0 0 30px 0")};
  margin: 0;
`;

export const InputGroupWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  border: 1px solid rgba(209, 224, 241, 1);
  line-height: 28px;
  border-radius: 4px;
  margin: ${(props) => (props.margin ? props.margin : "0")};

  &:focus-within {
    border: 1px solid rgba(20, 115, 230, 1);
  }

  &.error {
    border: 1px solid rgba(205, 55, 70, 1);
  }
`;

export const InputWrapper = styled.div`
  box-sizing: border-box;
  width: ${(props) => (props.width ? props.width : "100%")};
  display: flex;
  flex-direction: ${(props) => props.direction};
  position: ${(props) => props.position};
  margin: ${(props) => (props.margin ? props.margin : "0")};
  padding: ${(props) => (props.padding ? props.padding : "0")};
  justify-content: ${(props) => (props.justify ? props.justify : "")};
  align-items: ${(props) => (props.align ? props.align : "")};
  overflow: ${(props) => (props.overflow ? props.overflow : "")};

  top: ${(props) => props.top};
  left: ${(props) => props.left};
  bottom: ${(props) => props.bottom};
  right: ${(props) => props.right};

  z-index: ${(props) => props.zIndex};

  cursor: ${(props) => props.cursor};
  height: ${(props) => (props.height ? props.height : "")};
  gap: ${(props) => (props.gap ? props.gap : "")};
`;

export const HoverInputWrapper = styled(InputWrapper)`
  &:hover {
    border-radius: 4px;
    background-color: rgba(228, 237, 250, 1);
  }
`;

export const Label = styled.label`
  width: ${(props) => (props.width ? props.width : "100%")};
  line-height: 20px;

  &.noInternetTitle {
    margin-top: 56px;
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
    color: #000000;
    text-align: center;
  }
  &.noInternetLabel {
    margin-bottom: 28px;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #000000;
    text-align: center;
  }
  &.nosearchLabel {
    width: auto;
    font-weight: 400;
    font-size: 12px;
    line-height: 28px;
    color: #4e6382;
    margin: 0 0 16px 16px;
  }

  &.domainFailedLebel {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #4e6382;
    padding: 0;
    margin: 0;
  }

  &.userLabelinfo {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #28476a;
    margin: 0 0 16px 0;
    padding: 0;
  }

  &.imageErrorTitle {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #09274a;
    margin: 0;
    padding: 0;
    margin-bottom: 12px;
  }
  &.imageErrorMessage {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #09274a;
    margin: 0;
    padding: 0;
  }

  &.mailBoxDropLabel {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #09274a;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }

  &.dropMainLabel {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #09274a;
    padding: 0;
    margin: 0;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.tabletitle {
    padding: 0;
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #28476a;
    cursor: pointer;
  }

  &.tableActivity {
    padding: 0;
    margin: 0;
    font-weight: 400;
    font-size: 13px;
    line-height: 28px;
    color: #4e6382;
    cursor: pointer;
  }

  &.dashboard-noArticleLabel {
    padding: 0;
    margin: 40px 0 8px 0;
    //padding-bottom: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #09274a;
  }
  &.dashboard-noArticleLabelInfo {
    padding: 0;
    margin: 0;
    font-weight: 500;
    font-size: 13px;
    line-height: 17px;
    color: #4e6382;
  }

  &.adminSidebarLabel {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0;
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #28476a;
    cursor: pointer;
  }
  &.adminSidebarLabelSelected {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0;
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #09274A;
    cursor: pointer;
  }

  &.settingSidebarLabel {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0;
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #28476a;
    cursor: pointer;
  }

  &.dropDownHeader {
    margin: 0;
    padding: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #4e6382;
    margin-bottom: 5px;
  }

  &.setupCompleteHeader {
    margin: 0;
    padding: 0;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #09274a;
    padding-bottom: 4px;
  }

  &.setupcompletefooter {
    padding: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #4e6382;
  }

  &.dashboardHeader {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #09274a;
    padding: 0 0 5px 0;
  }
  &.dashboardLabel {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #28476a;
    padding: 0;
  }

  $.modalHeader {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #09274a;
    padding: 0;
  }

  &.deleteModalLabel {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    padding: 0;
    padding-bottom: 12px;
  }

  &.upgradePlanPopUpLabel {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
  }
  
  &.deleteModalHelperLabel {
    ffont-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #09274a;
    padding: 0;
    padding-bottom: 12px;
  }

  &.customDomainLabel {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #28476a;
    padding: 0;
    padding-bottom: 8px;
  }

  &.customDomainHelper {
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #28476a;
    padding: 0;
    padding-bottom: 12px;
  }

  &.label {
    color: #09274a;
    font-weight: 500;
    font-size: 14px;
    padding: 0 0 6px 0;
    line-height: 17px;
  }

  &.generalSettingLabel {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #09274a;
    padding: 0 8px 0 0;
  }

  &.modalLabel {
    padding: 0 10px 0 0;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #09274a;
  }

  &.modalFormLabel {
    padding: 0;
    padding-bottom: 8px;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #09274a;
  }

  &.label-info {
    padding: 0 0 16px 0;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #28476a;
  }

  &.label-info-noPad {
    padding: 0;
    margin: 0 10px 0 0;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #4e6382;
  }

  &.errorwait {
    color: #4e6382;
    font-weight: 400;
    font-size: 12px;
    line-height: 28px;
    margin-left: 12px;
    padding: 0;
  }

  &.error {
    font-weight: 400;
    font-size: 12px;
    line-height: 28px;
    color: #cd3746;
    margin-left: 12px;
    padding: 0;
  }
 
  &.maxlengthLabel {
    width: auto;
    position: absolute;
    top: 8px;
    right: 8px;
  }
  &.maxlength4Label {
    width: auto;
    position: absolute;
    top: 60px;
    right: 8px;
  }
  &.maxlength3Label {
    width: auto;
    position: absolute;
    top: 96px;
    right: 8px;
  }
  &.tooltipLabel {
    color: white;
    font-weight: 400;
    font-size: 14px;
  }
  &.dropDown {
    font-weight: 400;
    font-size: 13px;
    padding: 0;
    line-height: 20px;
    color: #28476a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  &.dropDownSelected {
    font-weight: 500;
    font-size: 13px;
    padding: 0;
    line-height: 20px;
    color: #09274a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  &.dashboardCategoryDropdown {
    margin: 0;
    padding: 0;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #28476a;
    cursor: pointer;
  }
  &.link-label {
    margin-top: 24px;
    color: rgba(20, 115, 230, 1);
    font-weight: 500;
    font-size: 13px;
    cursor: pointer;
  }

  &.link-custom-domain-label {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #1473e6;
    padding: 0;
    cursor: pointer;
    padding: 16px 0 0 0;
  }

  &.noPad {
    padding: 0;
  }

  &.maxlength2Label {
    width: auto;
    position: absolute;
    top: 42px;
    right: 8px;
  }

  &.searchHeading {
    color: rgba(9, 39, 74, 1);
    font-weight: 400;
    font-size: 12px;
    padding: 0;
    line-height: 28px;
  }
  &.searchLabel {
    color: rgba(9, 39, 74, 1);
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
  }
  &.cname {
    color: rgba(78, 99, 130, 1);
    padding: 0 0 8px 0;
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: 0px;
  }

  &.cname-placeholder {
    font-size: 13px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0px;
    color: rgba(9, 39, 74, 1);
    padding: 0 0 0 16px;

    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.snippetLabel {
    padding: 0;
    margin: 0 12px;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
  }

  &.userSearchboxLabel {
    margin: 0;
    padding: 0;
    font-weight: 400;
    font-size: 13px;
    line-height: 28px;
    color: #09274a;
  }

  &.categoryDrophead {
    font-weight: 400;
    font-size: 13px;
    line-height: 28px;
    color: #4e6382;
    padding: 0;
    margin: 0;
  }

  &.getStartedLabel {
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #28476a;
    padding: 0;
    margin: 0;
    margin-bottom: 35px;
  }
`;

export const Input = styled.input`
  margin: 0px;
  width: ${(props) => (props.width ? props.width : "100%")};
  font-size: 13px;
  padding: ${(props) => (props.padding ? props.padding : "6px 50px 6px 12px")};
  color: #09274a;
  background: transparent;
  border: ${(props) =>
    props.border ? props.border : "1px solid rgba(209, 224, 241, 1)"};
  border-left: ${(props) => props.borderLeft};
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : "4px"};
  line-height: 28px;
  font-weight: 400;
  z-index: 1;
  outline: none !important;
  ${(props) =>
    props.focusBorder
      ? ""
      : `&:focus {
                border: 1px solid rgba(20, 115, 230, 1);
            }`}

  &.error {
    border: 1px solid rgba(205, 55, 70, 1);
  }
  &.errorWithIcon {
    border: 1px solid rgba(205, 55, 70, 1);
    background: url(${errorIcon}) no-repeat;
    background-position: 98% 10px;
  }
  :placeholder-shown {
    color: #4e6382;
  }
  ::-moz-placeholder {
    color: #4e6382;
  }
  :-ms-input-placeholder {
    color: #4e6382;
  }
  ::-webkit-input-placeholder {
    color: #4e6382;
  }
`;

export const TextArea = styled.textarea`
  font-family: inherit;
  resize: none;
  width: ${(props) => (props.width ? props.width : "100%")};
  height: ${(props) => (props.height ? props.height : "100%")};
  font-size: 13px !important;
  padding: ${(props) => (props.padding ? props.padding : "6px 50px 6px 12px")};
  color: #09274a;
  background: transparent;
  border: ${(props) =>
    props.border ? props.border : "1px solid rgba(209, 224, 241, 1)"};
  border-left: 1px solid rgba(209, 224, 241, 1);
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : "4px"};
  line-height: ${(props) => props.lineHeight || "28px !important"};
  font-weight: 400;
  z-index: 1;
  outline: none !important;
  text-decoration: none;
  
  scrollbar-width: thin;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
    height:57px;
  }
   
  ::-webkit-scrollbar-track {
    border-radius: 13px;
  }
   
  ::-webkit-scrollbar-thumb {
    background: #D9D9D9;
    border-radius: 13px;
  }

  &:focus {
    border: ${(props) =>
    props.border ? props.border : "1px solid rgba(20, 115, 230, 1)"};
  }

  &.error {
    border: 1px solid rgba(205, 55, 70, 1);
  }
  &.errorWithIcon {
    border: 1px solid rgba(205, 55, 70, 1);
    background: url(${errorIcon}) no-repeat;
    background-position: 98% 10px;
  }
  :placeholder-shown {
    color: #4e6382;
  }
  ::-moz-placeholder {
    color: #4e6382;
  }
  :-ms-input-placeholder {
    color: #4e6382;
  }
  ::-webkit-input-placeholder {
    color: #4e6382;
  }
`;

export const ColorInput = styled.input.attrs({ type: "color" })`
  box-sizing: border-box;
  position: absolute;
  height: 100%;
  font-size: 13px;
  //padding: 6px 12px;
  color: rgba(9, 39, 74, 1);
  background: transparent;
  border: 0;
  border-radius: 0;
  line-height: 20px;
  font-weight: 400;
  outline: none !important;
  z-index: 5;
  border-right: 1px solid rgba(209, 224, 241, 1);
  cursor: pointer;
`;

export const StyledButton = styled.button`
  position: relative;
  font-family: "Inter";
  display: ${(props) => (props.display ? props.display : "flex")};
  width: ${(props) => props.width || ""};
  align-items: center;
  align-content: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  padding: ${(props) => props.padding || "6px 16px"};
  margin: ${(props) => props.margin};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  border-radius: 4px;
  outline: none !important;
  background-color: ${(props) =>
    props.color
      ? props.color
      : props.primary
        ? "rgba(20, 115, 230, 1)"
        : props.secondary
          ? "white"
          : props.delete
            ? "rgba(205, 55, 70, 1)"
            : "rgba(255, 255, 255, 1)"};
  border: 1px solid
    ${(props) => (props.secondary ? "rgba(20, 115, 230, 1)" : "white")};
  color: ${(props) =>
    props.primary
      ? "rgba(255, 255, 255, 1)"
      : props.secondary
        ? "rgba(20, 115, 230, 1)"
        : props.delete
          ? "rgba(255, 255, 255, 1)"
          : "rgba(40, 71, 106, 1)"};

  &:hover {
    background-color: ${(props) =>
    props.primary
      ? "rgba(64, 146, 245, 1)"
      : props.secondary
        ? "rgba(242, 246, 255, 1)"
        : props.delete
          ? "rgba(217, 156, 162, 1)"
          : "rgba(242, 246, 255, 1)"};
  }

  &.disable, &:disabled {
    background-color: ${(props) =>
    props.primary
      ? "rgba(214, 224, 235, 1)"
      : props.secondary
        ? "rgba(255, 255, 255, 1)"
        : "rgba(255, 255, 255, 1)"};
    border: 1px solid
      ${(props) =>
    props.secondary ? "rgba(214, 224, 235, 1)" : "rgba(255, 255, 255, 1)"};
    color: ${(props) =>
    props.primary
      ? "rgba(255, 255, 255, 1)"
      : props.secondary
        ? "rgba(214, 224, 235, 1)"
        : "rgba(214, 224, 235, 1)"};
  }
`;

export const IconButton = styled.div`
  position: relative;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  padding: 6px 23px;
  border-radius: ${(props) => props.borderRadius};
  outline: none !important;
  border: 1px solid rgba(209, 224, 241, 1);
  border-left: ${(props) => props.borderLeft};
  background: url(${(props) => props.Icon}) no-repeat;
  background-position: 50% 50%;
  cursor: pointer;
`;

export const DropDownBox = styled.div`
  position: absolute;
  width: 100%;
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 25%) 0 0 10px 0px;
  z-index: 100;
  background: rgba(255, 255, 255, 1);
  outline: none !important;
  user-select: none;
`;

export const DropDownList = styled.ul`
  padding: ${(props) => props.padding || "6px 0"};
  list-style: none;
  width: 100%;
  margin: 0;
  cursor: pointer;
`;

export const DropdownRow = styled.li`
  margin: 0;
  padding: 8px 16px;
  width: auto;
  height: auto;
  cursor: pointer;
  &: hover {
    background: rgba(242, 246, 255, 1);
  }
`;

export const ButtonIcon = styled.img`
  height: 18px;
  width: 18px;
  margin-right: 10px;
`;
